import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import moment from "moment";
import {
    ReferenceDot,
    PieChart,
    Pie,
    Cell,
    YAxis,
    CartesianGrid,
    Tooltip as RechartTooltip,
    Legend,
    ResponsiveContainer,
    ComposedChart,
    ReferenceArea,
    Brush,
    Label,
    ReferenceLine,
    Scatter,
    ScatterChart,
    Tooltip
} from 'recharts';
import {
    ConvertData, CustomTooltip, getAxisYDomain, getGroupedSeriesByGroupId,
    getGroupedSeriesByGroupment, GetXLSXData, ConvertDataForTwoPies, getGroupedSeriesByUUID
} from './ChartsV2Functions';
import "./ChartV2.css";
import uuid from "react-uuid";
import { selectDateOptions } from "components/Analyses/DatesOptions";

const RADIAN = Math.PI / 180;
const toPercent = (decimal, fixed = 0) => `${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(decimal * 100)}%`;

const getPercent = (value, total) => {
    const ratio = total > 0 ? value / total : 0;

    return toPercent(ratio, 2);
};
const renderTooltipContent = (o) => {
    const { payload, label } = o;
    const total = payload.reduce((result, entry) => result + entry.value, 0);

    return (
        <div style={{
            backgroundColor: 'rgba(255, 255,255, 0.85)', borderRadius: '4px', padding: '10px', paddingLeft: "10px",
            border: "1px solid #999999"
        }}>
            <p className="total"><b>{label}</b>{` (Total : ${total})`}</p>

            {payload.map((entry, index) => (
                <p key={`item-${index}`} style={{ color: entry.color }}>
                    {`${entry.name}: ${entry.value} (${getPercent(entry.value, total)})`}
                </p>
            ))}

        </div>
    );
};

const renderCustomizedLabelOutside = (props) => {

    return `${props.name + ' : ' + (props.percent * 100).toFixed(0)}%`;
};

const renderCustomizedLabelInside = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, group, name }) => {
    // console.log(percent, index, group, name);
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    if (percent < 0.05)
        return "";
    return (
        <text x={x} y={y} fill="white" textAnchor={'middle'} dominantBaseline="central">
            {(group || name) + ` : ${(percent * 100).toFixed(0)}%`}
        </text>
    );
};

const renderCustomizedLabelInsideLevelTwo = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, group, name }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    if (percent < 0.05)
        return "";
    return (
        // <text x={x} y={y} fill="white" textAnchor={'middle'} stroke="#000000" stroke-dashoffset="0" stroke-dasharray="100%" dominantBaseline="central">
        //     {name + ` : ${(percent * 100).toFixed(0)}%`}
        // </text>
        <text x={x} y={y} fill="#black" fontWeght="600" textAnchor={'middle'} dominantBaseline="central">
            {name + ` : ${(percent * 100).toFixed(0)}%`}
        </text>
    );
};



export default function ChartV2Pie(props) {
    const {  chart, data, setData } = props;
    const [activelegend, setActivelegend] = useState([]);

    const [groupedseries, setGroupedseries] = useState([]);
    const [datatwopies, setDatatwopie] = useState([]);


    console.log(data);
    useEffect(() => {
        chart.series.forEach((serie) => {
            serie.uuid = uuid();
        });
        let datatmp = ConvertData(chart);
        setData(datatmp);
        let groupedseriestmp;
        if (chart.distribution === 'no') {
            // console.log("getGroupedSeriesByUUID", chart.series);
            groupedseriestmp = getGroupedSeriesByUUID(chart);
        }
        else if (!chart.distributiongroupment || chart.distributiongroupment === 'no') {
            groupedseriestmp = getGroupedSeriesByGroupId(chart);
        }
        else
            groupedseriestmp = getGroupedSeriesByGroupment(chart);



        let activelegendtmp = [];
        groupedseriestmp.forEach((serie) => {
            activelegendtmp.push({ dataKey: serie.groupid, hide: false });
            serie.total = datatmp[0] ? Number(datatmp[0][serie.groupid]) : 0;
        });
        console.log(activelegendtmp);
        console.log(groupedseriestmp);
        setGroupedseries(groupedseriestmp);
        setActivelegend(activelegendtmp);
        GetXLSXData(chart, datatmp, groupedseriestmp);

        if (chart.twolevelpie) {
            let datatwopietmp = ConvertDataForTwoPies(datatmp, groupedseriestmp);
            setDatatwopie(datatwopietmp);
        }
        // console.log(datatmp);
    }, []);

    const handleLegendClick = (node) => {
        node.inactive = !node.inactive;
        let activelegendtmp = [...activelegend];
        activelegendtmp.find((legend) => legend.dataKey == node.dataKey).hide = !activelegendtmp.find((legend) => legend.dataKey == node.dataKey).hide;
        setActivelegend(activelegendtmp);
    };

    return (

        <ResponsiveContainer width="100%" height="100%">
        {
            chart.twolevelpie ?
                <PieChart
                    // width={500}
                    // height={300}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 40,
                    }}
                >
                    <defs>
                        {/* RED */}
                        <radialGradient id="colorRed" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#C53F3F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#8E0018" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorRed2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#9D3232" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#710013" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorRed3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#762525" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#55000E" stopOpacity={0.9} />
                        </radialGradient>

                        {/* ORANGE */}
                        <radialGradient id="colorOrange" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#FF763A" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#C54608" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorOrange2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#CC5E2E" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#9D3806" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorOrange3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#994622" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#762A04" stopOpacity={0.9} />
                        </radialGradient>

                        {/* YELLOW */}
                        <radialGradient id="colorYellow" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#D6D22F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#A1A100" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorYellow2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#ABA825" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#808000" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorYellow3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#807E1C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#606000" stopOpacity={0.9} />
                        </radialGradient>

                        {/* GREEN */}
                        <radialGradient id="colorGreen" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#91C73C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#5F9600" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGreen2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#749F30" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#4C7800" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGreen3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#577724" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#395A00" stopOpacity={0.9} />
                        </radialGradient>

                        {/* BLUE */}
                        <radialGradient id="colorBlue" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#3E8FC6" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#006295" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorBlue2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#31729E" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#004E77" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorBlue3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#255576" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#003A59" stopOpacity={0.9} />
                        </radialGradient>

                        {/* PURPLE */}
                        <radialGradient id="colorPurple" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#6B3CC8" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#340C96" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorPurple2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#5530A0" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#290978" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorPurple3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#402478" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#1F075A" stopOpacity={0.9} />
                        </radialGradient>

                        {/* GREY */}
                        <radialGradient id="colorGrey" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#9798A0" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#605F70" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGrey2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#787980" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#4C4C59" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGrey3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#5A5B60" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#393943" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE A */}
                        <radialGradient id="dpeA" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#008A32" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#476E00" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeA2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#006E28" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#385800" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeA3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#00521E" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#2A4200" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE B */}
                        <radialGradient id="dpeB" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#91C73C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#5F9600" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeB2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#749F30" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#4C7800" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeB3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#577724" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#395A00" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE C */}
                        <radialGradient id="dpeC" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#D6D22F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#A1A100" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeC2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#ABA825" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#808000" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeC3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#807E1C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#606000" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE D */}
                        <radialGradient id="dpeD" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#FFFF66" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#B5B548" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeD2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#CCCC51" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#909039" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeD3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#99993D" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#6C6C2B" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE E */}
                        <radialGradient id="dpeE" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#F8BB00" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#CE9A00" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeE2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#C69500" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#A47B00" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeE3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#947000" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#7B5C00" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE F */}
                        <radialGradient id="dpeF" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#FF763A" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#C54608" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeF2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#CC5E2E" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#9D3806" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeF3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#994622" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#762A04" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE G */}
                        <radialGradient id="dpeG" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#C53F3F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#8E0018" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeG2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#9D3232" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#710013" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeG3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#762525" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#55000E" stopOpacity={0.9} />
                        </radialGradient>
                    </defs>
                    <Tooltip
                        cursor={{ fill: 'transparent' }}
                        offset={0}

                        content={<CustomTooltip unit={chart.chartunit} />}
                    />
                    {/* <Legend
                        wrapperStyle={{ marginBottom: -40 }}
                        onClick={handleLegendClick}
                    /> */}

                    <Pie
                        data={data}
                        label={renderCustomizedLabelInside}
                        labelLine={false}
                        nameKey="group"
                        dataKey="total"
                        cx="50%" cy="50%" outerRadius={"70%"}
                    // fill={serie.color}
                    // hide={activelegend.find((legend) => legend.dataKey == serie.groupid).hide}
                    >
                        {data.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={chart.series.find((serie) => serie.originalid == entry.originalid)?.color}
                            />
                        ))}
                    </Pie>

                    <Pie
                        data={datatwopies}
                        labelLine={false}
                        nameKey="name"
                        dataKey="value"
                        cx="50%" cy="50%" innerRadius={"80%"} outerRadius={"100%"}
                        //  label={renderCustomizedLabelOutside}
                        label={renderCustomizedLabelInsideLevelTwo}
                    // fill={serie.color}
                    // hide={activelegend.find((legend) => legend.dataKey == serie.groupid).hide}
                    >
                        {datatwopies.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.color}
                            />
                        ))}
                    </Pie>



                </PieChart>
                :
                <PieChart
                    width={500}
                    height={300}

                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 40,
                    }}
                >
                    <defs>
                        <radialGradient id="colorRed" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#C53F3F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#8E0018" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorOrange" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#FF763A" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#C54608" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorYellow" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#D6D22F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#A1A100" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGreen" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#91C73C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#5F9600" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorBlue" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#3E8FC6" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#006295" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorPurple" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#6B3CC8" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#340C96" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGrey" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#9798A0" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#605F70" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeA" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#008A32" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#476E00" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeB" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#91C73C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#5F9600" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeC" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#D6D22F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#A1A100" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeD" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#FFFF66" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#B5B548" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeE" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#F8BB00" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#CE9A00" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeF" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#FF763A" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#C54608" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeG" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#C53F3F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#8E0018" stopOpacity={0.9} />
                        </radialGradient>
                    </defs>
                    <Tooltip
                        cursor={{ fill: 'transparent' }}
                        offset={0}

                        content={<CustomTooltip chart={chart} />}
                    />
                    <Legend
                        wrapperStyle={{ marginBottom: -40 }}
                    // onClick={handleLegendClick}
                    />

                    <Pie
                        data={groupedseries}
                        label={renderCustomizedLabelInside}
                        labelLine={false}
                        nameKey="groupname"
                        dataKey="total"
                        cx="50%" cy="50%"
                        isAnimationActive={false}
                    // fill={serie.color}
                    // hide={activelegend.find((legend) => legend.dataKey == serie.groupid).hide}
                    >
                        {groupedseries.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.color}
                            />
                        ))}

                    </Pie>

                </PieChart>
        }


    </ResponsiveContainer>

    );
}